import React from 'react';
import classnames from 'classnames';
import { useSelected } from 'slate-react';
import styles from './DividerLine.module.css';
import type {
  ComponentProps,
  DividerLineElement,
} from '../../../types/aha-editor';

interface DividerLineProps extends ComponentProps<DividerLineElement> {
  children: React.ReactNode;
}

const DividerLine: React.FC<DividerLineProps> = ({
  attributes,
  element,
  children,
}) => {
  const selected = useSelected();

  return (
    <div contentEditable={false} {...attributes}>
      {children}
      <hr
        className={classnames(styles.dividerLine, {
          [styles.selected]: selected,
        })}
      />
    </div>
  );
};

export default DividerLine;
